import { render } from "./ElectionPolicyView.vue?vue&type=template&id=5c5ba216&scoped=true"
import script from "./ElectionPolicyView.vue?vue&type=script&lang=js"
export * from "./ElectionPolicyView.vue?vue&type=script&lang=js"

import "./ElectionPolicyView.vue?vue&type=style&index=0&id=5c5ba216&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c5ba216"]])

export default __exports__